import * as React from 'react';

export default class Booking extends React.Component<{}, {}> {
  public render() {
    return <p>Booking instructions</p>;
  }
}



// WEBPACK FOOTER //
// ./src/pages/IntegrationInstructions/private/Booking.tsx